module.exports = __webpack_public_path__ + "img/15.828175b7.jpg";